import axios from "axios";

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

function authHeader() {
  const t = localStorage.getItem("token");
  return t ? { Authorization: `Bearer ${t}` } : {};
}

export async function askChat(message, conversation = []) {
  const res = await API.post(
    "/chat/ask",
    { message, conversation },
    { headers: { "Content-Type": "application/json", ...authHeader() } }
  );
  return res.data; // { reply, products?, intent, needLogin? }
}

export async function handoffToHuman(conversation = []) {
  const res = await API.post(
    "/chat/handoff",
    { conversation },
    { headers: { "Content-Type": "application/json", ...authHeader() } }
  );
  return res.data; // { url }
}